import { render, staticRenderFns } from "./EditProductDiscountPopover.vue?vue&type=template&id=6fb6ce76&"
import script from "./EditProductDiscountPopover.vue?vue&type=script&lang=js&"
export * from "./EditProductDiscountPopover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports